<template>
  <v-container class="page-container p-3">
    <ExpenseConfigContainer />
  </v-container>
</template>

<script>
import ExpenseConfigContainer from "@/components/Container/ExpenseConfigContainer.vue"
export default {
  components: { ExpenseConfigContainer },
}
</script>
